// Module
var code = "<div> <button class=\"mdl-button mdl-js-button mdl-button--raised mdl-button--colored g-btn-100 m-b-sm\" style=\"height: 45px; font-size: 16px\" ng-click=\"setFastDeal()\"> {{'unit.info.quick.book' | translate}} </button> </div> ";
// Exports
module.exports = code;